module.exports = __webpack_public_path__ + "img/-LV18rC1XdSwFTpKhg2O.77cb9120.jpg";